import React from 'react';
import { inject } from 'mobx-react';
import Link from 'core/components/Link';

const RegionLink = ({ $app, region, country, ...rest }) => {
  if ($app.isSubtenant) {
    return region;
  }

  return (
    <Link to={`/v4/core/quick-views/region/${encodeURIComponent(region)}/${country}`} {...rest}>
      {region}
    </Link>
  );
};

export default inject('$app')(RegionLink);
